const productionUrlRegex = /^(insights|optics|connect)?\.?dentsuactivation\.com$/;

export const STAGE = productionUrlRegex.test(window.location.hostname)
    ? 'prod'
    : 'dev';
